import * as THREE from 'three';
export const OrbitControls = require('three-orbit-controls')(THREE);




// WEBPACK FOOTER //
// ./src/components/Results/ResultsScene/util/controls.js